import React from "react";

interface FilterChipProps {
  label: string;
  onRemove: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove }) => (
  <div className="flex items-center gap-2 py-2 px-3 bg-lgray-200 border border-gray-300 rounded text-[#4A6784]">
    <span className="font-rubik font-medium text-xs leading-none whitespace-nowrap">{label}</span>
    <button
      onClick={onRemove}
      className="bg-transparent border-0 text-base text-[#4A6784] cursor-pointer p-0 leading-none w-[8px] h-[8px] flex items-center justify-center hover:text-[#334155]"
    >
      ×
    </button>
  </div>
);

export default FilterChip;
